import { applyMiddleware, compose, createStore } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import reducers from '../reducers'
import { history } from '../utils/routes'
import thunkMiddleware from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { createFilter } from 'redux-persist-transform-filter'
import { persistStore, persistReducer } from 'redux-persist'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'

const loadPartialMapFilter = createFilter(
  'map',
  null,
  ['activeGroup', 'activeTrap'],
)

const persistConfig = {
  storage,
  key: 'root',
  blacklist: ['toast', 'popovers', 'ui', 'progress', 'invites'],
  transforms: [
    loadPartialMapFilter
  ]
}

const persistedReducer = persistReducer(persistConfig, reducers)

export default function configureStore(initialState) {
  const middlewares = [
    // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
    reduxImmutableStateInvariant(),
    routerMiddleware(history),
    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunkMiddleware,
  ]
  /* eslint no-underscore-dangle: 0 */
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // add support for Redux dev tools

  const store = createStore(
    connectRouter(history)(persistedReducer),
    { ...(initialState || {}) },
    composeEnhancers(applyMiddleware(...middlewares)),
  )

  const persistor = persistStore(store)

  return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/store/configurePersistedStore.js